import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateSession200,
  CreateSession401,
  CreateSession500,
  GetSessionStatus200,
  InvalidateSession200,
  InvalidateSession500
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 유효한 JWT 토큰을 사용하여 Pay 서버에서 새로운 HTTP 세션을 생성합니다.
AuthServer 의존성 없이 독립적으로 세션을 관리합니다.

 * @summary JWT 토큰으로 새로운 세션 생성
 */
export const createSession = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateSession200>(
      {url: `/api/v1/auth/create-session`, method: 'POST'
    },
      options);
    }
  


export const getCreateSessionMutationOptions = <TError = CreateSession401 | CreateSession500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSession>>, void> = () => {
          

          return  createSession(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSession>>>
    
    export type CreateSessionMutationError = CreateSession401 | CreateSession500

    /**
 * @summary JWT 토큰으로 새로운 세션 생성
 */
export const useCreateSession = <TError = CreateSession401 | CreateSession500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSession>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createSession>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 현재 HTTP 세션과 JWT 인증 상태를 확인합니다.
세션 정보와 JWT 토큰 정보를 모두 반환합니다.

 * @summary 현재 세션 상태 확인
 */
export const getSessionStatus = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSessionStatus200>(
      {url: `/api/v1/auth/session-status`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSessionStatusQueryKey = () => {
    return [`/api/v1/auth/session-status`] as const;
    }

    
export const getGetSessionStatusInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getSessionStatus>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSessionStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionStatus>>> = ({ signal }) => getSessionStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSessionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSessionStatusInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionStatus>>>
export type GetSessionStatusInfiniteQueryError = unknown

/**
 * @summary 현재 세션 상태 확인
 */
export const useGetSessionStatusInfinite = <TData = Awaited<ReturnType<typeof getSessionStatus>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSessionStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSessionStatusInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSessionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSessionStatus>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSessionStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSessionStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionStatus>>> = ({ signal }) => getSessionStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSessionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSessionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionStatus>>>
export type GetSessionStatusQueryError = unknown

/**
 * @summary 현재 세션 상태 확인
 */
export const useGetSessionStatus = <TData = Awaited<ReturnType<typeof getSessionStatus>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSessionStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSessionStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 현재 HTTP 세션을 무효화합니다.
로그아웃 처리에 사용됩니다.

 * @summary 세션 무효화 (로그아웃)
 */
export const invalidateSession = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<InvalidateSession200>(
      {url: `/api/v1/auth/invalidate-session`, method: 'POST'
    },
      options);
    }
  


export const getInvalidateSessionMutationOptions = <TError = InvalidateSession500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invalidateSession>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof invalidateSession>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invalidateSession>>, void> = () => {
          

          return  invalidateSession(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvalidateSessionMutationResult = NonNullable<Awaited<ReturnType<typeof invalidateSession>>>
    
    export type InvalidateSessionMutationError = InvalidateSession500

    /**
 * @summary 세션 무효화 (로그아웃)
 */
export const useInvalidateSession = <TError = InvalidateSession500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invalidateSession>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof invalidateSession>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getInvalidateSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    